<template>
  <div class="list-con" :class="{ 'large-font-mode': pageData.largeFontMode }">
    <!--        名单列表 start        -->
    <div class="list-container flex flex-col align-center">
      <div
        v-for="item in pageData.diagRecords"
        :key="item.id"
        class="list-item w-full flex flex-row justify-between"
        @click="handleClickDiagRecord(item)"
      >
        <div class="name-con flex flex-row align-center">
          <img
            v-if="item.sexSign==='2'"
            class="profile"
            alt="头像"
            src="../../../../../../assets/treatment/profileFemale.png"
          >
          <img
            v-else
            class="profile"
            alt="头像"
            src="../../../../../../assets/treatment/profileMale.png"
          >
          <div class="name mr-5">{{ item.name }}</div>
          <el-tag size="mini">{{ item.stateSign|STATE_SIGN }}</el-tag>
        </div>
        <div class="info flex flex-row align-center">
          <div class="gender flex flex-row align-center">{{ item.sexSign === "1" ? "男" : "女" }}</div>
        </div>
      </div>
    </div>
    <!--        名单列表 end        -->
  </div>
</template>
<script>

import { findPage, getById, postData } from '@/api/ik/data/dataApi'

export default {
  filters: {
    /**
     * 就诊记录状态
     * @param stateSign
     * @returns {string}
     * @constructor
     */
    STATE_SIGN(stateSign) {
      switch (stateSign) {
        case "1":
          return "待就诊"
        case "2":
          return "待配药"
        case "3":
          return "待结算"
        case "4":
          return "待取药"
        case "5":
          return "已完成"
        case "6":
          return "已关闭"
        default:
          return ""
      }
    }
  },
  inject: ["pageData"],
  mounted() {
    this.findDiagRecord()
  },
  methods: {
    /**
     * 查询就诊记录
     */
    findDiagRecord() {
      const pd = {
        storeCode: this.pageData.storeCode,
        storeUserCode: this.pageData.storeUserCode
      }
      postData("clinic/treatment/treatment/diagrecord/find/findactivediagrecord", pd)
        .then(res => {
          this.pageData.diagRecords = res.data
          let index = false
          this.pageData.diagRecords.forEach(element => {
            if (element.code === this.pageData.activeDiagRecord.diagRecord.code) {
              index = true
            }
          })
          if (!index) {
            this.pageData.activePatientInfo = {}
            this.pageData.dispatchVisible = false
          }
        })
    },
    /**
     * 点击就诊记录
     * @param diagRecord 就诊记录
     */
    handleClickDiagRecord(diagRecord) {
      this.getPatientInfo(diagRecord.patientId)
      this.findHisDiagRecord(diagRecord.patientId)
      this.getActivePreDiagRecord(diagRecord.code)
    },
    /**
     * 获取病人信息
     * @param patientId
     */
    getPatientInfo(patientId) {
      const bgPath = "clinic/treatment/patient/patient"
      getById(bgPath, patientId)
        .then(res => {
          this.pageData.activePatientInfo = res.data.head
        })
    },
    /**
     * 查询历史诊疗记录
     * @param patientId
     */
    findHisDiagRecord(patientId) {
      const bgPath = "clinic/treatment/treatment/diagrecord"
      const pd = {
        storeCode: this.pageData.storeCode,
        stateSign: "5",
        patientId
      }
      findPage(bgPath, pd, 3, 1)
        .then(res => {
          this.pageData.hisTreatmentRecords = res.data.list
        })
    },
    /**
     * 获取进行中的预诊记录
     * @param code
     */
    getActivePreDiagRecord(code) {
      const url = "clinic/treatment/treatment/diagrecord/find/finddiagrecord"
      const pd = {
        code
      }
      postData(url, pd)
        .then(res => {
          this.pageData.resetActiveDiagRecord()
          this.pageData.activeDiagRecord = {
            ...this.pageData.activeDiagRecord,
            ...res.data
          }
          if (res.data.treatmentRecord.code) {
            postData('pharmacy/storage/agentpre/agentprescription/find/gettreatmentrecord', { code: res.data.treatmentRecord.code }).then(res => {
              console.log(res)
              this.pageData.activeDiagRecord.dsPrescription = res.data.agentPrescription || { // 代煎处方
                pharmacyCode: "",
                pharmacyName: "",
                doseNum: 0,
                dayDoseNum: 0
              }
              this.pageData.activeDiagRecord.dsPrescriptionItemList = res.data.agentPrescriptionItemList || []
              this.pageData.activeDiagRecord.djPrescription = res.data.chagentPrescription || { // 代煎处方
                pharmacyCode: "",
                pharmacyName: "",
                serveFeeSign: "00",
                doseNum: 0,
                dayDoseNum: 0,
                dayFreq: 0
              }
              this.pageData.activeDiagRecord.djPrescriptionItemList = res.data.chagentPrescriptionItemList || []
            })
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
  /* 大字模式样式 */
.large-font-mode {
  font-size: 1.2em;

  .label-con {
    .label {
      font-size: 18px;
      line-height: 28px;
    }
  }

  .el-form-item {
    margin-bottom: 10px;

    ::v-deep .el-form-item__label {
      font-size: 15px;
      line-height: 32px;
    }

    ::v-deep .el-input__inner,
    ::v-deep .el-input-number .el-input__inner {
      font-size: 15px;
      height: 36px;
      line-height: 36px;
    }

    ::v-deep .el-input-number {
      line-height: 34px;
    }
  }

  .el-col {
    margin-bottom: 8px;
  }
}
// 列表容器
.list-con {
  .list-search-input {
    width: 176px;
    height: 24px;
    background: #FFFFFF;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #E5E6EB;
    margin-bottom: 20px;
  }

  .list-container {
    height: 584px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 0;
    }

    .list-item {
      &:hover {
        cursor: pointer;
      }

      padding: 14px 12px;

      .name-con {
        .profile {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }

        .name {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: bold;
          font-size: 14px;
          color: #1D2129;
          line-height: 14px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .info {
        .gender {
          font-family: PingFang SC, PingFang SC, serif;
          font-weight: normal;
          font-size: 14px;
          color: #86909C;
          line-height: 14px;
          text-align: right;
          font-style: normal;
          text-transform: none;
        }
      }

    }
  }
}

@media (min-height: 920px) {
  // 列表容器
  .list-con {
    .list-search-input {
      width: 176px;
      height: 24px;
      background: #FFFFFF;
      border-radius: 2px 2px 2px 2px;
      border: 1px solid #E5E6EB;
      margin-bottom: 20px;
    }

    .list-container {
      height: 72.5vh;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        width: 0;
      }

      .list-item {
        &:hover {
          cursor: pointer;
        }

        padding: 14px 12px;

        .name-con {
          .profile {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }

          .name {
            font-family: PingFang SC, PingFang SC, serif;
            font-weight: bold;
            font-size: 14px;
            color: #1D2129;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }

        .info {
          .gender {
            font-family: PingFang SC, PingFang SC, serif;
            font-weight: normal;
            font-size: 14px;
            color: #86909C;
            line-height: 14px;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }
        }

      }
    }
  }
}
</style>
